module.exports = __webpack_public_path__ + "img/B47A5B_301E14_704A31_633C23-256px.8c7e8137.png";